import React from "react";

const NotificationPopup = ({ userName, message, type, onClose, onConfirm }) => {
    return (
        <div className="notification-popup">
            <div className="notification-popup__wrap">
                <div className="notification-body">
                    <div className="notification-popup__user">
                        <div className="notification-popup__user-image">
                            <i className="fa-light fa-user"></i>
                            <div className="notification-popup__user-image-initials">
                                {userName?.split(" ").map((i, name) => (
                                    <span key={i}>{name[0]}</span>
                                ))}
                            </div>
                        </div>
                        <div className="notification-popup__user-text">
                            <div className="notification-popup__user-name">{userName}</div>
                            <div className="notification-popup__message">
                                <span>{message}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="notification-popup__prompt">
                    {type === "confirm" && onConfirm && (
                        <>
                            <button className="notification-popup__button notification-popup__button--no" onClick={() => onClose(true)}>
                                <i className="fa-solid fa-circle-xmark"></i>
                                <span>No</span>
                            </button>
                            <button className="notification-popup__button notification-popup__button--yes" onClick={() => onConfirm()}>
                                <i className="fa-solid fa-circle-check"></i>
                                <span>Yes</span>
                            </button>
                        </>
                    )}

                    {(type === "notification" || !type) && (
                        <button className="notification-popup__button notification-popup__button--yes" onClick={() => onClose(true)}>
                            <i className="fa-solid fa-circle-check"></i>
                            <span>OK</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;
